import { Component, OnInit,Input,Output } from '@angular/core';
import { Code } from './../../code/button';
@Component({
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.less']
})
export class GridComponent implements OnInit {
code = Code;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/view/grid/grid.component.ts